import { render } from "./info_list_component.vue?vue&type=template&id=9772e670"
import script from "./info_list_component.vue?vue&type=script&lang=js"
export * from "./info_list_component.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__